import React, { useState } from "react";
import TextInput from "./TextInput";
import { Field } from "formik";
import { MDBBtn } from "mdb-react-ui-kit";
import { Spinner } from "stm-frontend-library";
import { SSO_BUTTON_LABEL, SSO_URL, SSO_APP_URL, SSO_AVAILABLE } from "../constants";

const LoginForm = ({ handleSubmit, isSubmitting }) => {
  const [showForm, setShowForm] = useState(!SSO_URL);

  const handleSSOClick = () => {
    window.location.href = SSO_URL;
  };

  const handleLoginWithSsoClick = () => {
    const ssoUrl = new URL(SSO_APP_URL);
    ssoUrl.searchParams.append('origin', window.location.origin);

    window.location.href = ssoUrl.toString();
  };

  const ssoButtonText = SSO_BUTTON_LABEL;

  const switchButton = (
    <MDBBtn
      color="light"
      rippleColor="dark"
      type="button"
      className="mt-3"
      onClick={() => setShowForm(!showForm)}
    >
      {showForm ? "Switch to SSO login" : "Switch to STM login"}
    </MDBBtn>
  );

  return (
    <form className="col-10 col-md-4" onSubmit={handleSubmit}>
      <span
        className="d-block text-center mb-3 display-4"
        style={{ fontSize: "2.8rem" }}
      >
        Log in
      </span>

      {SSO_URL && !showForm ? (
        <div className="text-center mt-4 d-grid">
          <MDBBtn className="btn btn-primary" type="button" onClick={handleSSOClick}>
            {ssoButtonText}
          </MDBBtn>
          {switchButton}
        </div>
      ) : (
        <>
          <Field
            component={TextInput}
            name="username"
            label="Username"
            type="text"
          />
          <Field
            component={TextInput}
            name="password"
            label="Password"
            type="password"
          />
          <div className="text-center mt-4">
            {isSubmitting ? (
              <Spinner />
            ) : (
              <div className="d-grid">
                <MDBBtn className="btn btn-primary" type="submit">
                  Login
                </MDBBtn>
                {SSO_AVAILABLE &&
                  <MDBBtn
                      className="btn btn-secondary mt-3"
                      onClick={handleLoginWithSsoClick}
                  >
                    Login with SSO
                  </MDBBtn>
                }
              </div>
            )}
          </div>
          {SSO_URL && (
            <div className="text-center d-grid">
              {switchButton}
            </div>
          )}
        </>
      )}
    </form>
  );
};

export default LoginForm;
